import { COLORS } from 'helpers/globals'

export default {
  editShape: {
    flex: '0 0 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    paddingBottom: '3rem',
    overflow: 'hidden',
    background: 'white'
  },
  header: {
    padding: '1rem 2rem',
    minHeight: '5rem',
    fontSize: '1.8rem',
    fontWeight: '400',
    background: COLORS.primary,
    color: 'white'
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    color: COLORS.primary,
    fontSize: '2.5rem',
    padding: '1rem 0'
  },
  deleteButton: {
    color: 'red'
  },
  colorButton: {
    background: COLORS.primary,
    width: '4rem',
    textAlign: 'center',
    borderRadius: '1rem'
  },
  colorIcon: {
    verticalAlign: '-.4rem'
  },
  filler: {
    padding: '2.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/EditShape/style.js